import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Switch, Route, withRouter } from 'react-router-dom';
import Helmet from 'react-helmet';
import {
  find, reduce, keyBy, filter,
  map, each, uniq, first, values,
} from 'lodash';
import { LinkContainer } from 'react-router-bootstrap';
import {
  Dropdown, MenuItem, Modal, NavItem,
} from 'react-bootstrap';
import Fa from 'react-fontawesome';

import requiredSetupMappings from '../../../../components/required-setup-mappings';
import NumberDisplay from '../../../../components/number-display';
import Counter from '../../../../components/counter';
import SearchForm from '../../../../components/search-form';
import ProgramDropdown from '../../components/program-dropdown';
import NominationNav from '../../components/nav';
import ProgressBar from '../../../../components/progress-bar';
import Spinner from '../../../../components/spinner';
import AlertIcon from '../../../../components/alert-icon';
import WinLossStats from '../../components/winloss-stats';
import UnlinkedContactTable from '../../components/unlinked-contact-table';
import RequiredTVProductMappingSetup from '../../components/ensure-tv-product-mapping';
import RequestFeedbackManager from '../../../../components/request-feedback-manager';

import { resetOpportunities, fetchOpportunities,
  winLossReset, winLossToogleAll, winLossEditOpportunity,
  winLossEditOpportunityUpdateContact,
  fetchClientTrackings, resetClientTrackings,
  submitSample,
  winLossEditOpportunityEditContact,
  winLossSelectOpportunity,
  winLossUnselectOpportunity,
  resetSavedParams,
  addSavedParams,
  removeSavedParams,
  fetchUnlinkedContacts,
  winLossFetchOpportunityContacts,
  winLossMassFetchOpportunityContacts,
} from '../../WinLossActions';
import { getOpportunities, getOpportunityLoading,
  getOpportunityLoaded, getOpportunityHasErrors, getOpportunityErrors,
  getWinLossEditingOpportunity,
  getWinLossPrograms, getWinLossProgramsMasterCheckboxStatus, getWinLossSubmitParams,
  getWinLossEditingOpportunityEditingContact,
  getTotalSaved, getSavedParamsLoaded, getSavedParamsLoading,
  getUnlinkedContacts, getUnlinkedContactLoading, getUnlinkedContactLoaded,
} from '../../WinLossReducer';

import { nominationToggleProductMapping, fetchClientInitiatives } from '../../NominationActions';
import { getPrograms } from '../../NominationReducer';
import { getIndexedProducts, getTVProductDictionary } from '../../../Setup/SetupReducer';
import { fetchAllProducts } from '../../../Setup/SetupActions';
import { getCanAccessToSalesforce } from '../../../Auth/AuthReducer';

import EditModal from '../../components/edit-modal';
import DispositionModal from '../../components/disposition-modal';
import EditContactModal from '../../components/edit-contact-modal';
import WarningModal from '../../components/warning-modal';
import OpportunityTable from '../../components/opportunity-table';

import styles from './styles.css';

// const PROGRAM_TYPE = 'Win Loss';
const TABLE_NAME = 'nominations-win-loss-table';
const SAVED_TABLE_NAME = 'nominations-win-loss-saved-table';
const UNLINKED_CONTACT_TABLE_NAME = 'nominations-win-loss-unlinked-contact-table';

const SUBMIT_STATUS = {
  SUBMITTING: 'submitting',
  SUCCESS: 'success',
  FAIL: 'fail',
};

export default function createClass(programType = 'Win Loss') {
  class WinLossPage extends Component {
    constructor(props) {
      super(props);
      this.state = {
        selectedProgramId: props.programId,
        editModalTab: 1,
        disabled: false,
        editedOpportunities: [],
        editedProgram: null,
        showWarning: false,
        submitStatus: null,
        submitResults: null,
        submitErrors: null,
        status: null, // null, submitted, unsubmitted
        showDispositions: false,
        selectedOpportunityDispositions: null,
        countSelected: 0,
        tvProductMappings: {},
      };
      this.hanldeSubmit = this.hanldeSubmit.bind(this);
      this.handleConfirmWarning = this.handleConfirmWarning.bind(this);
      this.handleToggleProductMapping = this.handleToggleProductMapping.bind(this);
      this.handleProgramChange = this.handleProgramChange.bind(this);
      this.handleDismissWarning = this.handleDismissWarning.bind(this);
      this.hanldeReset = this.hanldeReset.bind(this);
      this.handleFormChange = this.handleFormChange.bind(this);
      this.handleContactInfoChange = this.handleContactInfoChange.bind(this);
      this.showEditModal = this.showEditModal.bind(this);
      this.showDispositionsDetail = this.showDispositionsDetail.bind(this);
      this.hideDispositionsDetail = this.hideDispositionsDetail.bind(this);
      this.handleRequestUnselectOpportunity = this.handleRequestUnselectOpportunity.bind(this);
      this.handleRequestSelectOpportunity = this.handleRequestSelectOpportunity.bind(this);
      this.handleRequestToggleAll = this.handleRequestToggleAll.bind(this);
      this.hanldeRequestSave = this.hanldeRequestSave.bind(this);
      this.hanldeRequestUnsave = this.hanldeRequestUnsave.bind(this);
      this.handleOnUpdateOpportunity = this.handleOnUpdateOpportunity.bind(this);
    }

    componentDidMount() {
      this.props.dispatch(winLossReset());
      this.props.dispatch(resetOpportunities());
      this.props.dispatch(fetchAllProducts())
        .then(
          () => {
            const program = this.getCurrentProgram();
            if (program) {
              this.props.dispatch(fetchUnlinkedContacts(program.client_id, program.program_id));
              this.props.dispatch(fetchClientInitiatives(program.client_id, program.program_id))
                .then(() => {
                  this.mounted = true;
                  this.initTVProductMappings();
                  // this.loadTrackings();
                });
            }
          },
          () => {
            console.log('ERROR FETCHING PRODUCTS');
          },
        );
    }
    componentWillUnmount() {
      this.mounted = false;
    }

    getCurrentProgram() {
      const { selectedProgramId } = this.state;
      const { programs } = this.props;
      const selectedPrograms = programs[programType];
      let selectedProgram = null;
      if (selectedProgramId) {
        selectedProgram = find(selectedPrograms, { program_id: selectedProgramId });
      }
      return selectedProgram;
    }

    initTVProductMappings() {
      const { tvProductDictionary, programId } = this.props;
      const tvProductMappings = reduce(tvProductDictionary, (items, mappings, tsProductId) => {
        const validMappings = filter(mappings, { program_type: programType, program_id: programId });
        items[tsProductId] = [];
        each(validMappings, (m) => {
          items[tsProductId].push(m.id);
        });
        return items;
      }, {});
      this.setState({ tvProductMappings });
    }
    
    hanldeSubmit(isSaved = false) {
      const { winLossSubmitParams } = this.props;      
      const program = this.getCurrentProgram();
      if (program) {
        const tvProducts = program && program.initiatives && program.initiatives.products ? program.initiatives.products : [];
        const indexedTVProducts = keyBy(tvProducts, 'id');

        const clientId = program.client_id;
        const selectedProgramId = program.program_id;
        const params = {
          opportunities: winLossSubmitParams[isSaved ? 'savedParams' : 'params'].map((winLossSubmitParam) => {
            let tvProductIds = [];
            const productNames = [];
            if (winLossSubmitParam.selected_product_ids) {
              tvProductIds = winLossSubmitParam.selected_product_ids;
              each(tvProductIds, (id) => {
                if (indexedTVProducts[id]) {
                  productNames.push(indexedTVProducts[id].name);
                }
              });
            }
            // const tvProductId = tvProductIds.length > 0 ? tvProductIds[0] : null;
            const productName = productNames.length > 0 ? productNames.join(', ') : null;
            return {
              ...winLossSubmitParam,
              // tv__initiativeId: selectedProgramId,
              // tv__clientId: clientId,
              // tv__productId: tvProductId,
              // tv__productIds: tvProductIds,
              // selected_product_id: null,
              // selected_product_ids: null,
              tv__productIds: tvProductIds,
              product: productName,
            };
          }),
        };
        this.setState({
          submitStatus: SUBMIT_STATUS.SUBMITTING, disabled: true, submitResults: null, submitErrors: null,
        });
        this.props.dispatch(submitSample(clientId, selectedProgramId, params))
          .then(
            (results) => {
              this.setState({ submitStatus: SUBMIT_STATUS.SUCCESS, disabled: false, submitResults: results });
              this.loadTrackings(true);
              this.props.dispatch(winLossReset());
            },
            (errors) => {
              this.setState({ submitStatus: SUBMIT_STATUS.FAIL, disabled: false, submitErrors: errors.data || errors });
            },
          );
      }
    }

    hanldeRequestSave() {
      const program = this.getCurrentProgram();
      if (program) {
        const { winLoss } = this.props;
        const clientId = program.client_id;
        const selectedProgramId = program.program_id;
        return this.props.dispatch(addSavedParams(clientId, selectedProgramId, values(winLoss)));
      }
      return Promise.reject(new Error('Missing program'));
    }

    hanldeRequestUnsave() {
      const program = this.getCurrentProgram();
      if (program) {
        const { winLossSubmitParams } = this.props;
        const clientId = program.client_id;
        const selectedProgramId = program.program_id;

        const stats = winLossSubmitParams.savedStats;
        const selected = map(stats.selected || [], 'opportunity_id');
        return this.props.dispatch(removeSavedParams(clientId, selectedProgramId, selected));
      }
      return Promise.reject(new Error('Missing program'));
    }

    handleConfirmWarning(program) {
      this.setState({
        editedOpportunities: [],
        editedProgram: null,
        showWarning: false,
        selectedProgramId: program.program_id,
      });
      this.props.dispatch(fetchClientInitiatives(program.client_id, program.program_id))
        .then(() => {
          this.loadTrackings();
        });
    }
    handleToggleProductMapping(program, tvProductId, tsProductId) {
      this.props.dispatch(nominationToggleProductMapping(program.program_id, program.client_id, tvProductId, tsProductId));
    }
    
    handleRequestToggleAll(saved = false) {
      const { opportunities } = this.props;
      const unloaded = filter(opportunities, opportunity => opportunity.contactStatus !== 'loaded');
      if (unloaded.length === 0) {
        return this.props.dispatch(winLossToogleAll(saved, this.state.tvProductMappings));
      }
      return new Promise((resolve, reject) => {
        this.props.dispatch(winLossMassFetchOpportunityContacts(map(unloaded, 'opportunity_id')))
          .then(
            () => {
              this.props.dispatch(winLossToogleAll(saved, this.state.tvProductMappings))
                .then(
                  (r) => {
                    resolve(r);
                  },
                  (e) => {
                    reject(e);
                  },
                );
            },
            (e) => {
              reject(e);
            },
          );
      });
    }

    handleProgramChange(program) {
      const { selectedProgramId, disabled } = this.state;
      const { winLoss } = this.props;
      if (disabled) {
        return;
      }
      if (program.program_id !== selectedProgramId) {
        const currentProgram = this.getCurrentProgram();
        const initiatives = currentProgram.initiatives || {};
        const buyerTypes = keyBy(initiatives.buyerTypes, 'id');
        const buyerRoles = keyBy(initiatives.buyerRoles, 'id');
        const buyerTags = keyBy(initiatives.tags, 'id');
        const editedOpportunities = reduce(winLoss, (opportunities, opportunity) => {
          const editedContacts = reduce(opportunity.selected_contacts, (contacts, contact) => {
            const buyerRole = buyerRoles[contact.buyer_role] ? buyerRoles[contact.buyer_role].name : null;
            const buyerType = buyerTypes[contact.buyer_type] ? buyerTypes[contact.buyer_type].name : null;
            const tags = reduce(contact.tags, (t, tag) => {
              if (buyerTags[tag]) {
                t.push(buyerTags[tag].name);
              }
              return t;
            }, []);
            const edited = buyerRole !== null || buyerType !== null || tags.length > 0;
            if (edited) {
              contacts.push({
                ...contact, buyer_role: buyerRole, buyer_type: buyerType, tags,
              });
            }
            return contacts;
          }, []);
          if (editedContacts.length > 0) {
            opportunities.push({ ...opportunity, selected_contacts: editedContacts });
          }
          // todo: check products
          return opportunities;
        }, []);
        if (editedOpportunities.length > 0) {
          this.setState({ editedOpportunities, editedProgram: program, showWarning: true });
        } else {
          this.handleConfirmWarning(program);
        }
      }
    }
    handleDismissWarning() {
      this.setState({ editedOpportunities: [], editedProgram: null, showWarning: false });
    }
    hanldeReset() {
      this.props.dispatch(winLossReset());
      this.props.dispatch(resetOpportunities());
    }

    handleOnUpdateOpportunity() {
      this.setState({ countSelected: this.state.countSelected + 1 });
    }
    handleFormChange(criteria) {
      this.props.dispatch(winLossReset()).then(() => {
        this.props.dispatch(fetchOpportunities(criteria)).then((results) => {
          this.loadTrackings(true);
          const { opportunities, total } = results;
          const returnResults = opportunities.length;
          if (total && returnResults < total) {
            const el = (
              <div>
                Your search return more than <NumberDisplay value={total} precision={0} /> results.<br />
                For optimal performance, only the latest <NumberDisplay value={returnResults} precision={0} /> will be displayed.
              </div>
            );
            this.context.addNotification(el, { type: 'warning', autoClose: 30 * 1000 });
          }
        });
      });
    }

    loadTrackings(loadSavedParams = false) {
      const { opportunities } = this.props;
      const program = this.getCurrentProgram();
      this.props.dispatch(resetClientTrackings());
      if (loadSavedParams) {
        this.props.dispatch(resetSavedParams());
      }
      if (program && program.client_id) {
        const opportunityIds = map(opportunities, 'opportunity_id');
        this.props.dispatch(fetchClientTrackings(program.client_id, program.program_id, opportunityIds, loadSavedParams));
      }
    }
    handleContactInfoChange(contact) {
      this.props.dispatch(winLossEditOpportunityUpdateContact(contact));
    }
    showEditModal(opportunity, editModalTab = 1) {
      this.setState({ editModalTab });
      this.props.dispatch(winLossEditOpportunity(opportunity));
    }
    showDispositionsDetail(selectedOpportunityDispositions) {
      this.setState({ showDispositions: true, selectedOpportunityDispositions });
    }
    hideDispositionsDetail() {
      this.setState({ showDispositions: false, selectedOpportunityDispositions: null });
    }
    handleRequestSelectOpportunity(opportunity) {
      if (opportunity.contactStatus === 'loaded') {
        return this.props.dispatch(winLossSelectOpportunity(opportunity, this.state.tvProductMappings));
      }
      if (!opportunity.contactStatus) {
        return new Promise((resolve, reject) => {
          this.props.dispatch(winLossFetchOpportunityContacts(opportunity.opportunity_id))
            .then(
              () => {
                this.props.dispatch(winLossSelectOpportunity(opportunity, this.state.tvProductMappings))
                  .then(
                    (r) => {
                      resolve(r);
                    },
                    (e) => {
                      reject(e);
                    },
                  );
              },
              (error) => {
                reject(error);
              },
            );
        });
      }
      return Promise.reject('loading');
    }
    handleRequestUnselectOpportunity(opportunity) {
      return this.props.dispatch(winLossUnselectOpportunity(opportunity));
    }
    renderStatusToggle() {
      const { status } = this.state;
      const items = [
        { value: null, label: 'All Opportunities' },
        { value: 'submitted', label: 'Submitted Opportunities' },
        { value: 'unsubmitted', label: 'Not Submitted Opportunities' },
      ];
      const activeItem = find(items, { value: status }) || first(items);
      return (
        <Dropdown id="submit-status-dropdown">
          <Dropdown.Toggle bsSize="sm">
            {activeItem === undefined && <span>none</span>}
            {activeItem !== undefined && <span>{activeItem.label}</span>}
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {items.map((item) => {
              const isActive = activeItem !== undefined && activeItem.value === item.value;
              return (
                <MenuItem
                  eventKey={item.value}
                  active={isActive}
                  key={item.value}
                  onSelect={() => {
                    this.setState({ status: item.value });
                  }}
                >
                  {item.label}
                </MenuItem>
              );
            })}
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    renderError() {
      const { opportunityErrors, opportunityHasErrors } = this.props;
      if (!opportunityHasErrors) {
        return null;
      }
      let message = opportunityErrors.messge;
      if (opportunityErrors.data) {
        message = opportunityErrors.data.message || opportunityErrors.data;
      }
      return (
        <div className="alert alert-danger">
          <Fa name="exclamation-triangle" /> {message}
        </div>
      );
    }

    renderTable(program) {
      const {
        opportunities, winLoss,
        masterCheckboxStatus,
        editingOpportunity,
      } = this.props;
      const {
        disabled, countSelected,
      } = this.state;
      if (opportunities.length === 0) {
        return (
          <div className="alert alert-warning">No records found.</div>
        );
      }

      return (
        <OpportunityTable
          disabled={disabled}
          tableName={TABLE_NAME}
          opportunities={opportunities}
          winLoss={winLoss}
          countSelected={countSelected}
          masterCheckboxStatus={masterCheckboxStatus.allStatus}
          program={program}
          editingOpportunity={editingOpportunity}
          requestShowDispositionsDetail={this.showDispositionsDetail}
          requestEditOpportunity={this.showEditModal}
          requestshowEditProduct={(o) => { this.showEditModal(o, 4); }}
          requestshowEditContacts={(o) => { this.showEditModal(o, 3); }}
          requestSelectOpportunity={this.handleRequestSelectOpportunity}
          requestUnselectOpportunity={this.handleRequestUnselectOpportunity}
          requestToggleAll={this.handleRequestToggleAll}
          topControls={this.renderStats()}
        />
      );
    }

    renderSavedTable(program) {
      const {
        opportunities, winLoss,
        masterCheckboxStatus,
        editingOpportunity,
        savedParamsLoading,
      } = this.props;
      if (savedParamsLoading) {
        return (<ProgressBar />);
      }
      const { disabled, countSelected } = this.state;
      const deals = filter(opportunities, { is_saved: true });
      if (deals.length === 0) {
        return (
          <div className="alert alert-warning">No records found.</div>
        );
      }

      return (
        <OpportunityTable
          disabled={disabled}
          tableName={SAVED_TABLE_NAME}
          opportunities={deals}
          countSelected={countSelected}
          winLoss={winLoss}
          isSaved
          masterCheckboxStatus={masterCheckboxStatus.savedStatus}
          program={program}
          editingOpportunity={editingOpportunity}
          requestShowDispositionsDetail={this.showDispositionsDetail}
          requestEditOpportunity={this.showEditModal}
          requestshowEditProduct={(o) => { this.showEditModal(o, 4); }}
          requestshowEditContacts={(o) => { this.showEditModal(o, 3); }}
          requestSelectOpportunity={this.handleRequestSelectOpportunity}
          requestUnselectOpportunity={this.handleRequestUnselectOpportunity}
          requestToggleAll={() => this.handleRequestToggleAll(true)}
          topControls={this.renderStats(true)}
        />
      );
    }

    renderStats(isSaved = false) {
      const {
        programs, winLossSubmitParams, indexedProducts,
      } = this.props;
      const { disabled } = this.state;
      const selectedPrograms = programs[programType];
      const selectedProgram = this.getCurrentProgram();
      const stats = isSaved ? winLossSubmitParams.savedStats : winLossSubmitParams.stats;
      const { contacts, selectedProductIds } = stats;
      const products = reduce(selectedProductIds, (results, id) => {
        if (indexedProducts[id]) {
          results.push(indexedProducts[id]);
        }
        return results;
      }, []);

      const countContacts = contacts.length;
      const countOpportunities = isSaved ? winLossSubmitParams.savedParams.length : winLossSubmitParams.params.length;
      const countSelected = stats.selected ? stats.selected.length : 0;
      const invalid = stats.invalidOpportunities && stats.invalidOpportunities > 0 ? (<div style={{ paddingTop: 5 }} className="pull-right"><Fa className="text-danger" name="exclamation-triangle" /> <NumberDisplay value={stats.invalidOpportunities} precision={0} suffix="invalid opportunity" suffixIsUnit /></div>) : null;
      return (
        <div className={`panel panel-default ${styles.panel}`}>
          <div className="panel-body">
            <div className="clearfix">
              {invalid}
              <div className="pull-left">
                <span className={styles.panelCopy}>
                  Selected:
                  {' '}
                  <Counter value={countOpportunities}>
                    <NumberDisplay value={countOpportunities} precision={0} suffix="opportunity" suffixIsUnit />
                  </Counter>
                  {' with '}
                  <Counter value={countContacts}>
                    <NumberDisplay value={countContacts} precision={0} suffix="contact" suffixIsUnit />
                  </Counter>
                </span>
                &nbsp;
                <ProgramDropdown
                  disabled={disabled}
                  showSaveButton={!isSaved}
                  showUnsaveButton={isSaved}
                  disabledSubmit={countOpportunities === 0}
                  disabledUnsave={countSelected === 0}
                  programs={selectedPrograms}
                  program={selectedProgram}
                  tvProducts={selectedProgram && selectedProgram.initiatives && selectedProgram.initiatives.products ? selectedProgram.initiatives.products : []}
                  products={products}
                  onProgramChange={this.handleProgramChange}
                  onSubmit={() => {
                    this.hanldeSubmit(isSaved);
                  }}
                  onToggleProductMapping={this.handleToggleProductMapping}
                  requestSave={this.hanldeRequestSave}
                  requestUnsave={this.hanldeRequestUnsave}
                />
              </div>
            </div>
          </div>
        </div>
      );
    }
    renderSubmitModal() {
      const { submitStatus, submitErrors, submitResults } = this.state;
      let opportunityIds = [];
      let contactIds = [];
      let errorMessage = '';
      if (submitStatus === SUBMIT_STATUS.SUCCESS) {
        each((submitResults || {}).added_sample, (sample) => {
          opportunityIds.push(sample.opportunityId);
          contactIds.push(sample.contactId);
        });
        opportunityIds = uniq(opportunityIds);
        contactIds = uniq(contactIds);
      } else if (submitStatus === SUBMIT_STATUS.FAIL) {
        errorMessage = submitErrors.message || 'Error';
      }
      return (
        <Modal backdrop="static" show={submitStatus !== null} keyboard={false} bsSize="sm">
          <Modal.Body>
            {submitStatus === SUBMIT_STATUS.SUBMITTING &&
              <div className="text-center">
                <p>&nbsp;</p>
                <Spinner />
                <p><em>one moment please...</em></p>
              </div>
            }
            {submitStatus === SUBMIT_STATUS.SUCCESS &&
              <div className="text-center">
                <p>&nbsp;</p>
                <AlertIcon />
                <p>
                  <NumberDisplay value={opportunityIds.length} precision={0} suffix="opportunity" suffixIsUnit />
                  {' and '}
                  <NumberDisplay value={contactIds.length} precision={0} suffix="contact" suffixIsUnit /> has been submitted.
                </p>
              </div>
            }
            {submitStatus === SUBMIT_STATUS.FAIL &&
              <div className="text-center">
                <div className="alert alert-danger">{errorMessage}</div>
              </div>
            }
          </Modal.Body>
          {(submitStatus === SUBMIT_STATUS.SUCCESS || submitStatus === SUBMIT_STATUS.FAIL) &&
            <Modal.Footer>
              <button type="button" className="btn btn-block btn-lg btn-primary" onClick={() => { this.setState({ submitStatus: null }); }}>
                OK
              </button>
            </Modal.Footer>
          }
        </Modal>
      );
    }

    renderUnlinkedTable() {
      const { unlinkedLoading, unlinkedCount } = this.props;
      if (unlinkedLoading) {
        return (
          <ProgressBar />
        );
      }
      if (unlinkedCount === 0) {
        return (
          <div className="alert alert-warning">No records found</div>
        );
      }
      return (
        <UnlinkedContactTable
          isWinLoss
          tableName={UNLINKED_CONTACT_TABLE_NAME}
        />
      );
    }

    renderTabs(program) {
      const {
        totalSaved, subNav,
        savedParamsLoading,
        unlinkedLoading, unlinkedCount,
        opportunities,
      } = this.props;
      return (
        <div>
          <ul className="nav nav-tabs">
            {subNav.map((p) => {
              const isSaved = p.type === 'saved';
              const isUnlinked = p.type === 'unlinked';
              let subComp = null;
              if (isSaved) {
                if (savedParamsLoading) {
                  subComp = (<Fa name="spinner" spin />);
                } else if (totalSaved > 0) {
                  subComp = (<span className="badge">{totalSaved}</span>);
                }
              } else if (isUnlinked) {
                if (unlinkedLoading) {
                  subComp = (<Fa name="spinner" spin />);
                } else if (unlinkedCount > 0) {
                  subComp = (<span className="badge"><NumberDisplay value={unlinkedCount} precision={0} /></span>);
                }
              } else if (opportunities.length > 0) {
                subComp = (<span className="badge"><NumberDisplay value={opportunities.length} precision={0} /></span>);
              }
              return (
                <LinkContainer exact key={p.path} to={p.url}>
                  <NavItem>{p.label} {subComp}</NavItem>
                </LinkContainer>
              );
            })}
          </ul>
          <p />
          <Switch>
            {subNav.map(p => (
              <Route
                exact
                key={p.path}
                path={p.path}
                render={() => {
                  if (p.type === 'table') {
                    return this.renderTable(program);
                  } else if (p.type === 'saved') {
                    return this.renderSavedTable(program);
                  } else if (p.type === 'unlinked') {
                    return this.renderUnlinkedTable();
                  }
                  return null;
                }}
              />
            ))}
          </Switch>
        </div>
      );
    }

    renderModals(program) {
      const {
        showWarning, editedOpportunities,
        editedProgram, editModalTab,
        showDispositions, selectedOpportunityDispositions,
        tvProductMappings,
      } = this.state;
      const { editingContact } = this.props;
      const products = program && program.initiatives && program.initiatives.products ? program.initiatives.products : [];
      
      return (
        <div>
          {this.renderSubmitModal()}
          <WarningModal
            isOpen={showWarning}
            opportunities={editedOpportunities}
            program={editedProgram}
            onClose={this.handleDismissWarning}
            onConfirm={this.handleConfirmWarning}
          />
          <EditModal
            tab={editModalTab}
            products={products}
            tvProductMappings={tvProductMappings}
            onUpdateOpportunity={this.handleOnUpdateOpportunity}
          />
          <DispositionModal
            isOpen={showDispositions}
            program={program}
            opportunityId={selectedOpportunityDispositions ? selectedOpportunityDispositions.opportunity_id : null}
            onClose={this.hideDispositionsDetail}
          />
          <EditContactModal
            program={program}
            onContactChange={this.handleContactInfoChange}
            contact={editingContact}
            onClose={() => {
              this.props.dispatch(winLossEditOpportunityEditContact(null));
            }}
          />
        </div>
      );
    }


    render() {
      const {
        disabled, submitStatus,
      } = this.state;
      const {
        opportunityLoading, opportunityLoaded,
        opportunityHasErrors, programId,
      } = this.props;

      const program = this.getCurrentProgram();
      const programProducts = program && program.initiatives && program.initiatives.products ? program.initiatives.products : [];
      

      return (
        <div className="container">
          <Helmet title={`${programType} | Nominations`} />
          <RequestFeedbackManager />
          <RequiredTVProductMappingSetup programType={programType} programId={programId}>
            {(loading, hasSetup, products, alert) => (
              <div>
                <div className="clearfix">
                  <div className="pull-left" style={{ paddingBottom: 10 }}>
                    <NominationNav />
                  </div>
                  {!loading && hasSetup &&
                    <div className="pull-right">
                      <SearchForm
                        onReset={this.hanldeReset}
                        onSearchChange={this.handleFormChange}
                        disabled={disabled}
                        loadRecommendedCriteria={false}
                        type="nominations/win-loss"
                        defaultCriteria={{
                          type: 'groupAND',
                          values: [
                            {
                              tag: 'closeDate',
                              type: 'include',
                              values: 'last-90-days',
                            },
                          ],
                        }}
                        pullRight
                      />
                    </div>
                  }
                </div>
                <p />
                {loading && <ProgressBar />}
                {!loading && hasSetup &&
                  <div>
                    {this.renderModals(program)}
                    {opportunityLoading && !opportunityLoaded && <div><ProgressBar /></div>}
                    {!opportunityLoading && opportunityLoaded &&
                      <div>
                        <WinLossStats
                          submitStatus={submitStatus}
                        />
                        {this.renderTabs(program)}
                      </div>
                    }
                    {!opportunityLoading && opportunityHasErrors && this.renderError()}
                  </div>
                }
                {!loading && !hasSetup &&
                  <div>
                    {programProducts.length === 0 && <div className="alert alert-warning">There is no TruVoice products available for <strong>{program.name}</strong></div>}
                    {programProducts.length > 0 && alert}
                  </div>
                }
              </div>
            )}
          </RequiredTVProductMappingSetup>
        </div>
      );
    }
  }
  // Retrieve data from store as props
  function mapStateToProps(state) {
    return {
      opportunities: getOpportunities(state),
      opportunityLoading: getOpportunityLoading(state),
      opportunityLoaded: getOpportunityLoaded(state),
      opportunityhasErrors: getOpportunityHasErrors(state),
      opportunityErrors: getOpportunityErrors(state),
      editingOpportunity: getWinLossEditingOpportunity(state),
      winLoss: getWinLossPrograms(state),
      programs: getPrograms(state),
      masterCheckboxStatus: getWinLossProgramsMasterCheckboxStatus(state),
      winLossSubmitParams: getWinLossSubmitParams(state),
      indexedProducts: getIndexedProducts(state),
      editingContact: getWinLossEditingOpportunityEditingContact(state),
      canAccessToSalesforce: getCanAccessToSalesforce(state),
      totalSaved: getTotalSaved(state),
      savedParamsLoading: !getSavedParamsLoaded(state) || getSavedParamsLoading(state),
      unlinkedLoading: getUnlinkedContactLoading(state) || !getUnlinkedContactLoaded(state),
      unlinkedCount: getUnlinkedContacts(state).length,
      tvProductDictionary: getTVProductDictionary(state),
    };
  }
  WinLossPage.propTypes = {
    programId: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    opportunities: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    opportunityLoading: PropTypes.bool.isRequired,
    opportunityLoaded: PropTypes.bool.isRequired,
    opportunityHasErrors: PropTypes.bool,
    opportunityErrors: PropTypes.shape({}),
    editingContact: PropTypes.shape({}),
    editingOpportunity: PropTypes.shape({}),
    winLossSubmitParams: PropTypes.shape({}).isRequired,
    winLoss: PropTypes.shape({}).isRequired,
    masterCheckboxStatus: PropTypes.shape({
      allStatus: PropTypes.string.isRequired,
      savedStatus: PropTypes.string.isRequired,
    }).isRequired,
    programs: PropTypes.shape({}).isRequired,
    indexedProducts: PropTypes.shape({}).isRequired,
    totalSaved: PropTypes.number.isRequired,
    savedParamsLoading: PropTypes.bool,
    unlinkedLoading: PropTypes.bool,
    unlinkedCount: PropTypes.number,
    subNav: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    tvProductDictionary: PropTypes.shape({}),
  };
  WinLossPage.defaultProps = {
    editingOpportunity: null,
    editingContact: null,
    opportunityErrors: null,
    opportunityHasErrors: false,
    savedParamsLoading: true,
    unlinkedLoading: true,
    unlinkedCount: 0,
    tvProductDictionary: {},
    indexedOpportunityContacts: {},
  };
  WinLossPage.contextTypes = {
    router: PropTypes.object,
    addNotification: PropTypes.func.isRequired,
  };
  return withRouter(connect(mapStateToProps)(requiredSetupMappings(WinLossPage, ['stage'])));
}

